import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
const airtableGetPractice = httpsCallable(functions, "airtable-getPractice");
const airtableGetCases = httpsCallable(functions, "airtable-getCases");
const airtableGetCase = httpsCallable(functions, "airtable-getCase");
const airtableUpdateCase = httpsCallable(functions, "airtable-updateCase");

export async function getPractice(slug) {
  const { data } = await airtableGetPractice({ slug });
  return data;
}

export async function getCases({ practiceSlug, filterEmail, offset }) {
  const { data } = await airtableGetCases({
    practiceSlug,
    filterEmail,
    offset,
  });
  return data;
}

export async function getCase(caseId) {
  const { data } = await airtableGetCase({ caseId });
  return data;
}

export async function updateCase({ caseId, fields }) {
  const { data } = await airtableUpdateCase({ caseId, fields });
  return data;
}
